import {inject, InjectionToken, Pipe, PipeTransform} from '@angular/core';
import {MuacLevel} from '../constants/muac-level.enum';

// Accepted types
export type SdLevel = 'SD3-' | 'SD2-' | 'SD1-' | 'SD0' | 'SD1' | 'SD2' | 'SD3';

// O MUAC mede desnutrição AGUDA (não crónica). Os rótulos casam EXATAMENTE com
// MuacLevel — o mesmo texto vai para o Firebase (visit.level) e é usado em
// filtros case-sensitive.
export const SD_LEVEL_LABELS = new InjectionToken<
    Partial<Record<SdLevel, string>>
>('SD_LEVEL_LABELS', {
    factory: () => ({
        'SD3-': MuacLevel.SEVERE_ACUTE_MALNUTRITION,     // 'Desnutrición aguda severa'
        'SD2-': MuacLevel.MODERATE_ACUTE_MALNUTRITION,   // 'Desnutrición aguda moderada'
        'SD1-': MuacLevel.RISK_OF_ACUTE_MALNUTRITION,    // 'Riesgo de desnutrición aguda'
        'SD0': MuacLevel.OUTSIDE_OF_RISK_ZONE,           // 'Niño fuera de la zona de riesgo'
        'SD1': MuacLevel.OUTSIDE_OF_RISK_ZONE,
        'SD2': MuacLevel.OUTSIDE_OF_RISK_ZONE,
        'SD3': MuacLevel.OUTSIDE_OF_RISK_ZONE,
    }),
});

@Pipe({
    name: 'muacMalnutritionLevel',
    pure: true,
})
export class MuacMalnutritionLevelPipe implements PipeTransform {
    private labels = inject(SD_LEVEL_LABELS);

    /**
     * @param value  Nível SD (ex.: 'SD2-')
     * @param fallback Texto opcional caso não exista rótulo (default: próprio value)
     */
    transform(value: SdLevel | string | null | undefined, fallback?: string): string {
        if (!value) {
            return fallback ?? 'No medido';
        }
        const v = value as SdLevel;
        return this.labels[v] ?? fallback ?? String(value);
    }
}
